module.exports = __webpack_public_path__ + "static/media/thank-you-illustration.dc8d3d39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/thank-you-illustration.svg
// module id = 2185
// module chunks = 0